import { useEffect } from 'react';

const useKeyboardEvent = (code: string, eventFunc: () => void) => {
  useEffect(() => {
    const handleKeyboardEvent = (e: KeyboardEvent) => {
      e.code === code && eventFunc();
    };

    document.addEventListener('keyup', handleKeyboardEvent);

    return document.removeEventListener('keyup', handleKeyboardEvent);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code]);
};

export default useKeyboardEvent;
